import * as Interfaces from 'interfaces';
import { SupportedCountriesList } from 'utils/constants';

export type Values = Pick<Interfaces.Common.FormValues, 'assess'>;

export const EmptyAddress = {
  isOverseasAddress: false,
  overseas: {
    country: '',
    info: {
      basic: ''
    }
  },
  fullDetails: {
    id: '',
    fullAddress: '',
    postCode: '',
    state: '',
    suburb: '',
    lga: '',
    country: ''
  },
  summaryData: {
    label: '',
    value: ''
  }
};

export const initialValues: Values = {
  assess: {
    vaccinationStatus: '',
    exemptionReason: [
      {
        code: 'international-exemption-application',
        value: 'International exemption application',
        selected: true
      }
    ],
    Depart: {
      date: '',
      country: SupportedCountriesList[0].value,
      from: '',
      fromAddressCountry: 'AUS',
      quarantine: {
        fromQuarantine: false,
        hotel: ''
      },
      fromAddress: EmptyAddress,
      homeAddressCountry: SupportedCountriesList[0].value,
      homeAddress: EmptyAddress,
      targetPlace: '',
      target: EmptyAddress,
      returningVicInvalidDestination: false,
      returningVicInvalidHome: false,
      homeAddressIsDestination: false
    },
    otherText: '',
    reasons: undefined,
    SupportingDocuments: {
      driversLicence: {
        registrationState: 'VIC',
        givenNames: '',
        familyName: '',
        dateOfBirth: '',
        consent: false,
        licenceNo: ''
      }
    }
  }
};
